var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrownFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "METAL-1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8e612d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rarity_Frame",
    "data-name": "Rarity Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rarity_Frame-2",
    "data-name": "Rarity Frame-2",
    className: "cls-1",
    d: "M0,3.94V248.8a3.57,3.57,0,0,0,3.57,3.57H176.43A3.57,3.57,0,0,0,180,248.8h0V3.94A3.57,3.57,0,0,0,176.43.37H3.57A3.57,3.57,0,0,0,0,3.94ZM167.21,243.81H12.36a3.57,3.57,0,0,1-3.58-3.56h0v-227a3.57,3.57,0,0,1,3.57-3.57H167.21a3.57,3.57,0,0,1,3.57,3.57h0v227a3.57,3.57,0,0,1-3.57,3.57Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownFrame);
export default __webpack_public_path__ + "static/media/brownFrame.198f63b9af5409d9cabcca4fa9d1ccb2.svg";
export { ForwardRef as ReactComponent };